import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Edit from './edit';
import Save from './save';

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: '#0061FE',
    src: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="currentColor"
      >
        <path d="M5 5h14a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm1 2v11h12V7H6z" />
        <rect x="8" y="10" width="8" height="1.6" rx="0.8" />
        <rect x="8" y="13.5" width="5" height="1.6" rx="0.8" />
        <circle cx="12" cy="4" r="2.6" />
      </svg>
    ),
  },
});
